import React, { useState } from "react";

/** Small two-step remove control (no popup): ✕ → "Remove? Yes / No". */
export function RowDelete({ label, onConfirm, disabled }) {
  const [asking, setAsking] = useState(false);
  const [busy, setBusy] = useState(false);
  if (disabled) return null;
  if (!asking) {
    return (
      <button
        type="button"
        className="eg-icon-btn"
        aria-label={`Remove ${label}`}
        title="Remove"
        onClick={() => setAsking(true)}
      >
        ✕
      </button>
    );
  }
  return (
    <span className="eg-confirm" role="group" aria-label={`Confirm remove ${label}`}>
      <button
        type="button"
        className="eg-link is-danger"
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          try {
            await onConfirm();
          } finally {
            setBusy(false);
            setAsking(false);
          }
        }}
      >
        {busy ? "…" : "Remove"}
      </button>
      <button type="button" className="eg-link" onClick={() => setAsking(false)}>
        Keep
      </button>
    </span>
  );
}
